import React, { ChangeEvent, useContext, useEffect, useState } from "react";
import { AddTextAreaField } from "./container/components/AddTextAreaField";
import { CreateArtifactContext } from "../../../context/CreateArtifactContext";

interface EditPopupJornalsProps {
  isOpen: boolean;
  editNotes?: string;
  onClose: () => void;
  onSave: (editNotes: string) => void;
  onChange?: (e: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => void;
  charAllowed?: number;
}

export const EditPopupJornals = ({ isOpen, editNotes, onClose, onSave, onChange, charAllowed = 150 }: EditPopupJornalsProps) => {
  const { contentData } = useContext(CreateArtifactContext);
  const [editNote, setEditNote] = useState(editNotes || "");
  const [originalNote, setOriginalNote] = useState(editNotes || "");
  const [isValidInput, setIsValidInput] = useState(false);

  useEffect(() => {
    setEditNote(editNotes || "");
    setOriginalNote(editNotes || "");
  }, [editNotes]);

  useEffect(() => {
    setIsValidInput(editNote.length >= 3 && editNote !== originalNote);
  }, [editNote, originalNote]);

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-gray-800 bg-opacity-50">
      <div className="p-6 bg-white rounded-lg shadow-lg w-96">
        <div className="relative w-full min-w-[200px] mb-2">
          <div className="flex items-center space-x-2">
            <span className="text-lg font-bold">Edit Note</span>
          </div>
          <p className="mb-4 text-sm text-gray-400">Update the text.</p>
          <AddTextAreaField
            name={""}
            title={""}
            note={""}
            placeholder={"Note"}
            index={1}
            height={150}
            charAllowed={charAllowed}
            value={editNote}
            onChange={e => {
              setEditNote(e.target.value);
            }}
          />
          <div className="flex justify-center w-full gap-10 mt-[15px]">
            <button
              id="'editBtn"
              type="submit"
              onClick={() => onSave(editNote)}
              className={
                (isValidInput ? "bg-black text-white cursor-pointer" : "bg-gray-400 text-white disabled-link") +
                " flex items-center justify-center px-3 py-2 text-sm font-normal text-center p-1 border-2 border-gray-500 rounded-lg w-1/2"
              }
              disabled={!isValidInput}
            >
              Done
            </button>
            <button
              type="button"
              onClick={onClose}
              className="flex items-center justify-center w-1/2 p-1 px-3 py-2 text-sm font-normal text-center text-black bg-white border-2 border-black rounded-lg cursor-pointer"
            >
              Cancel
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};
